var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
var Browser = function Browser(props) {
  return React.createElement(
    Icon,
    _extends({ viewBox: '0 0 16 14' }, props),
    React.createElement(
      'g',
      null,
      React.createElement(
        'g',
        { fill: 'currentColor', fillRule: 'evenodd' },
        React.createElement('path', { d: 'M15 3H1V1.5a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5V3zm0 9.5a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5V4h14v8.5zM14.5 0h-13C.673 0 0 .673 0 1.5v11c0 .827.673 1.5 1.5 1.5h13c.827 0 1.5-.673 1.5-1.5v-11c0-.827-.673-1.5-1.5-1.5z'
        }),
        React.createElement('path', { d: 'M11.712 8.464l-2.075 2.192a.5.5 0 0 0 .726.687l2.738-2.89-2.743-2.803a.5.5 0 1 0-.715.699l2.069 2.115zM6 11.5a.5.5 0 0 0 .36-.847L4.288 8.5 6.36 6.347a.5.5 0 1 0-.72-.694L2.899 8.5l2.741 2.847A.498.498 0 0 0 6 11.5'
        })
      )
    )
  );
};
/*eslint-enable */

export default Browser;
//# sourceMappingURL=Browser.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Icons/dist/components/Browser.js